/// <amd-module name="Traceability/Common/ImageDetails" />
import React = require("react");
import { VssComponent, WrappedComponent } from "VSS/Platform/Layout";

export interface ImageDetailsProps {
    imageUri: string;
    onBackButtonClick: () => void;
}

export class ImageDetails extends VssComponent<ImageDetailsProps, {}> {
    public render() {
        return (
            <WrappedComponent
                wrappedType={"run-summary-container-image-details"}
                dependencies={["ms.vss-build-web.common-library", "ms.vss-build-web.container-image"]}
                {...this.props}
            />
        );
    }
}
